import { Button, Result } from "antd";
import type { FallbackRender } from "@sentry/react";

/**
 * Error fallback component for Sentry.ErrorBoundary
 * Displays a user-friendly error message when an unhandled error occurs
 */
export const SentryErrorFallback: FallbackRender = ({ resetError }) => {
  const handleGoHome = () => {
    window.location.href = "/";
  };

  const handleRetry = () => {
    resetError();
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "24px",
      }}
    >
      <Result
        status="error"
        title="Algo salió mal"
        subTitle="Ha ocurrido un error inesperado. Nuestro equipo ha sido notificado y estamos trabajando para solucionarlo."
        extra={[
          <Button type="primary" key="retry" onClick={handleRetry}>
            Reintentar
          </Button>,
          <Button key="home" onClick={handleGoHome}>
            Ir al inicio
          </Button>,
        ]}
      />
    </div>
  );
};

export default SentryErrorFallback;
